import React from 'react';
import './MostrarPuntaje.css';

const MostrarPuntaje = ({aparato, nombre, club, ejecucion, dificultad, scoreType}) => {
    
    const totalScore = ejecucion + dificultad;
    
    return (
        <>
        {/* score type - USAG */}
        {scoreType === "USAG" ? (
            <div className={`fondo-puntaje ${aparato} fig-style`}>

                <div className='fila-fig'>
                    {/* logo colegio */}
                    {club && (
                        <img className="imagen-colegio-fig" src={`/images/${club}.jpg`}/>
                    )}
                    {/* nombre */}
                    {nombre && (
                        <p className='nombre-atleta-fig'>{nombre}</p>
                    )}
                </div>
                
                <div className='fila-puntaje-fig'>
                    {ejecucion && (
                        <p className='puntaje-atleta-fig'>{parseFloat(ejecucion).toFixed(3)}</p>
                    )}
                </div>

            </div>
        ) : (
            <div className={`fondo-puntaje ${aparato} fig-style`}>

                <div className='fila-fig'>
                    {/* logo colegio */}
                    {club && (
                        <img className="imagen-colegio-fig" src={`/images/${club}.jpg`}/>
                    )}
                    {/* nombre */}
                    {nombre && (
                        <p className='nombre-atleta-fig'>{nombre}</p>
                    )}
                </div>
                
                <div className='fila-puntaje-fig'>
                    {(ejecucion && dificultad) && (
                        <div className='puntajes-col'>
                            <p className='puntajes-col-text-e'>E: {parseFloat(ejecucion).toFixed(3)}</p>
                            <p className='puntajes-col-text-d'>D: {parseFloat(dificultad).toFixed(3)}</p>
                        </div>
                    )}

                    {(totalScore) && (
                        <p className='puntaje-atleta-fig'>{parseFloat(totalScore).toFixed(3)}</p>
                    )}
                </div>

            </div>
        )}
       </>
    );
};

export default MostrarPuntaje;